import { keyMeasurementGroup } from "@workspace/api-zod/measurement-review";
import type { MeasurementReviewField } from "./measurement-review";

/** Known checklist measurements are never displaced by a small-job suggestion cap. */
export function checklistReviewFields(fields: MeasurementReviewField[]) {
  const known = fields.filter(f => f.original &&
    keyMeasurementGroup(f.original.label, f.unit, f.subjectKind));
  const result = [...known];
  for (const f of known) {
    const group = keyMeasurementGroup(f.original!.label, f.unit, f.subjectKind);
    const roofOpening = group === "roof" && /\b(rooflight|lantern|opening)\b/i.test(f.label);
    const namedWall = ["internal-walls", "external-walls"].includes(group || "") && f.subjectKind === "wall" &&
      !/\bsupporting work\b/i.test(f.subjectLabel || "");
    const pair = group === "rooms" || group === "roof" && !roofOpening ? ["length", "width"] :
      namedWall ? ["length", "height"] :
      roofOpening ? ["width", "height"] :
      ["doors", "windows", "internal-openings"].includes(group || "") ? ["width", "height"] : undefined;
    if (!pair || f.unit !== "m") continue;
    const axis = f.label.match(/\b(length|width|height)\b/i)?.[0];
    if (!axis || !pair.includes(axis.toLowerCase())) continue;
    const partner = pair.find(a => a !== axis.toLowerCase())!;
    const label = f.label.replace(new RegExp(`\\b${axis}\\b`, "i"), partner);
    const existing = fields.find(p => p.unit === f.unit && (
      p.label.toLowerCase() === label.toLowerCase() ||
      f.subjectId && p.subjectId === f.subjectId && new RegExp(`\\b${partner}\\b`, "i").test(p.label)
    ));
    result.push(existing || {
      id: `pair-${f.id}-${partner}`.slice(0, 100), label, unit: "m", value: "",
      note: `No ${partner} identified for this location. Leave blank if unknown.`,
      subjectId: f.subjectId, subjectLabel: f.subjectLabel, subjectKind: f.subjectKind,
    });
  }
  return result;
}
